import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { DefaultBorder } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	replacePreviousSuggestionsText: {
		color: THEME.colors.text.light,
		fontSize: 14,
		marginTop: THEME.spacing.sm,
	},
	assistantDefaultMessageContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	generationForm: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	contentTypeCheckboxes: {
		display: 'flex',
		gap: THEME.spacing.md,
		flexWrap: 'wrap',
	},
	contentTypeCheckboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	contentTypeLabel: {
		fontSize: 14,
		cursor: 'pointer',
	},
	brandingSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	brandingRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	brandingLabel: {
		fontSize: 14,
		cursor: 'pointer',
	},
	brandingLabelDisabled: {
		color: THEME.colors.text.light,
		cursor: 'default',
	},
	brandingHelperText: {
		fontSize: 13,
		color: THEME.colors.text.light,
	},
	instructionsCounterAddon: {
		justifyContent: 'flex-end',
	},
	instructionsCounter: {
		fontSize: 12,
		fontWeight: 400,
		color: THEME.colors.text.light,
	},
	instructionsCounterOver: {
		color: THEME.colors.danger.dark,
	},
	preferencesSection: {
		display: 'flex',
		flexDirection: 'column',
		border: DefaultBorder,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
	},
	preferencesToggle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 12px',
		fontSize: 13,
		fontWeight: 500,
		color: THEME.colors.text.light,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		width: '100%',
		textAlign: 'left',
	},
	preferencesChevron: {
		display: 'inline-block',
		transition: 'transform 0.2s ease',
		fontSize: 12,
	},
	preferencesChevronExpanded: {
		transform: 'rotate(180deg)',
	},
	preferencesContent: {
		padding: '0 12px 12px',
	},
});
